import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pullRequestStaleLabel: {
    id: 'frontbucket.dashboard.overview.pullRequest.pullRequestStaleLabel',
    description: 'Text for state lozenge showing a pull request is stale',
    defaultMessage: 'STALE',
  },
  month: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.month',
    description: 'Age of a pull request, or a typical review time, in months',
    defaultMessage: '{months, plural, one {a month} other {{months} months}}',
  },
  day: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.day',
    description: 'Age of a pull request, or a typical review time, in days',
    defaultMessage: '{days, plural, one {a day} other {{days} days}}',
  },
  hour: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.hour',
    description: 'Age of a pull request, or a typical review time, in hours',
    defaultMessage: '{hours, plural, one {an hour} other {{hours} hours}}',
  },
  minute: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.minute',
    description: 'Age of a pull request, or a typical review time, in minutes',
    defaultMessage:
      '{minutes, plural, one {a minute} other {{minutes} minutes}}',
  },
  second: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.second',
    description: 'Age of a pull request, or a typical review time, in seconds',
    defaultMessage:
      '{seconds, plural, one {a second} other {{seconds} seconds}}',
  },
  prOpenVsUsual: {
    id: 'frontbucket.dashboard.overview.pullRequest.tooltip.prOpenForUsualMerged',
    description:
      'Information about pull request about how long it is open for, followed by an information about the usual merge time for this repository',
    defaultMessage:
      'This pull request has been <b>open</b> for {created}, when usually pull requests in this repository are merged within {usual}.',
  },
});
